import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable:directive-selector
  selector: '[ls-bold]'
})
export class BodyBoldDirective {
  @HostBinding('class.cr-text--bold') public bold = true;
}
